import { render } from "./CompanyIcon.vue?vue&type=template&id=27403bfa&scoped=true&ts=true"
import script from "./CompanyIcon.vue?vue&type=script&lang=ts"
export * from "./CompanyIcon.vue?vue&type=script&lang=ts"

import "./CompanyIcon.vue?vue&type=style&index=0&id=27403bfa&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27403bfa"]])

export default __exports__